export default __webpack_public_path__ + "static/media/lili.0cc1ada8.jpg";